import { Button } from "@/components/ui/button";
import { Dialog, DialogHeader, DialogBody, DialogFooter } from "@/components/ui/dialog";
import { AdminDialogHeading } from "@/components/admin/AdminDialogHeading";
import { WarningCircle } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

interface Props {
  testId: string | null;
  onClose: () => void;
  onConfirm: (id: string) => void;
}

export function TestDeleteDialog({ testId, onClose, onConfirm }: Props) {
  const { t } = useTranslation();
  return (
    <Dialog open={Boolean(testId)} onClose={onClose}>
      <DialogHeader onClose={onClose}>
        <AdminDialogHeading
          icon={WarningCircle}
          title={t("tests.admin.confirmDeleteTitle")}
          description={t("tests.admin.confirmDeleteBody")}
          tone="destructive"
        />
      </DialogHeader>
      <DialogBody className="flex flex-col gap-4">
        <p className="text-sm text-muted-foreground">
          {t("tests.admin.confirmDeleteBody")}
        </p>
      </DialogBody>
      <DialogFooter>
        <Button type="button" variant="outline" onClick={onClose}>
          {t("common.cancel")}
        </Button>
        <Button
          type="button"
          variant="destructive"
          onClick={() => testId && onConfirm(testId)}
        >
          {t("common.delete")}
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
